import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import Header_vue_vue_type_script_setup_true_lang_default from "./Header.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                           */
//#region src/v2/blocks/operation-block/components/Header.vue
var Header_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Header_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-3a29d7a0"]]);
//#endregion
export { Header_default as default };

//# sourceMappingURL=Header.vue.js.map